module.exports = __webpack_public_path__ + "static/media/valor1.a30e3a19.png";